// IP地址查询图标
export const IpIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="12" r="10"></circle>
  <line x1="2" y1="12" x2="22" y2="12"></line>
  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
</svg>`;

// Base64编解码图标
export const Base64Icon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M4 17l6-6-6-6"></path>
  <path d="M20 7l-6 6 6 6"></path>
  <line x1="12" y1="19" x2="12" y2="5"></line>
</svg>`;

// JSON格式化图标
export const JsonIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M8 4c-1.5 0 -3 1 -3 3v10c0 2 1.5 3 3 3"></path>
  <path d="M16 4c1.5 0 3 1 3 3v10c0 2 -1.5 3 -3 3"></path>
  <path d="M8 9h4"></path>
  <path d="M8 15h6"></path>
</svg>`;

// 时间戳转换图标
export const TimestampIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="12" r="10"></circle>
  <polyline points="12 6 12 12 16 14"></polyline>
  <path d="M12 22V18"></path>
  <path d="M18 22v-4"></path>
  <path d="M6 22v-4"></path>
</svg>`;

// UUID生成器图标
export const UuidIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="3" width="18" height="18" rx="2"></rect>
  <path d="M8 7v10"></path>
  <path d="M16 7v10"></path>
  <path d="M12 7v10"></path>
  <path d="M7 12h10"></path>
</svg>`;

// 二维码生成器图标
export const QrcodeIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="3" width="7" height="7"></rect>
  <rect x="14" y="3" width="7" height="7"></rect>
  <rect x="14" y="14" width="7" height="7"></rect>
  <rect x="3" y="14" width="7" height="7"></rect>
</svg>`;

// 图片裁剪图标
export const CropIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M6 2v14a2 2 0 0 0 2 2h14"></path>
  <path d="M18 22V8a2 2 0 0 0-2-2H2"></path>
</svg>`;

// URL编解码图标
export const UrlIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
</svg>`;

// 密码生成器图标
export const PasswordIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  <circle cx="12" cy="16" r="1"></circle>
</svg>`;

// Markdown编辑器图标
export const MarkdownIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M4 6h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"></path>
  <path d="M7 15V9l3 3 3-3v6"></path>
  <path d="M17 15h.01"></path>
  <path d="M17 12h.01"></path>
  <path d="M17 9h.01"></path>
</svg>`;

// Excel转JSON图标
export const Excel2JsonIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
  <polyline points="14 2 14 8 20 8"></polyline>
  <path d="M8 13h8"></path>
  <path d="M8 17h8"></path>
  <path d="M8 9h1"></path>
</svg>`;

// Excel在线编辑器图标
export const ExcelIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
  <line x1="3" y1="9" x2="21" y2="9"></line>
  <line x1="3" y1="15" x2="21" y2="15"></line>
  <line x1="9" y1="3" x2="9" y2="21"></line>
  <line x1="15" y1="3" x2="15" y2="21"></line>
</svg>`;

// 下班倒计时图标
export const CountDownIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="12" r="10"></circle>
  <polyline points="12 6 12 12 16 14"></polyline>
  <path d="M12 12L8 8"></path>
</svg>`;

// 英文名生成器图标
export const NameIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
  <circle cx="12" cy="7" r="4"></circle>
  <path d="M16 11h6"></path>
  <path d="M19 8v6"></path>
</svg>`;

export const RegExpIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M17 3v10"></path>
  <path d="M10 3v10"></path>
  <path d="M3 3l18 18"></path>
  <path d="M4 7h16"></path>
  <path d="M7 17L17 7"></path>
</svg>`;

export const ColorIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="12" r="10"></circle>
  <path d="M12 2v20"></path>
  <path d="M2 12h20"></path>
  <path d="M12 8a4 4 0 0 0 0 8"></path>
</svg>`;

export const TextDiffIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="4" width="7" height="16" rx="1"></rect>
  <rect x="14" y="4" width="7" height="16" rx="1"></rect>
  <path d="M7 8h-1"></path>
  <path d="M7 12h-2"></path>
  <path d="M7 16h-1"></path>
  <path d="M18 8h-1"></path>
  <path d="M18 12h-2"></path>
  <path d="M18 16h-1"></path>
  <path d="M10 12h4"></path>
</svg>`;

export const CodeBeautifierIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <polyline points="16 18 22 12 16 6"></polyline>
  <polyline points="8 6 2 12 8 18"></polyline>
  <line x1="12" y1="2" x2="12" y2="22"></line>
</svg>`;

export const ImageCompressorIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
  <circle cx="8.5" cy="8.5" r="1.5"></circle>
  <polyline points="21 15 16 10 5 21"></polyline>
  <path d="M19 9l-4 4"></path>
</svg>`;